exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".query-form[data-v-476550b4] {\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  margin: 0 auto;\n}\n.result[data-v-476550b4] {\n  margin-top: 20px;\n}\n.result .result-content[data-v-476550b4] {\n    border: 1px solid #ccc;\n    margin: 10px;\n    padding: 20px;\n    border-radius: 4px;\n    max-height: 300px;\n    overflow: auto;\n    font-family: monospace;\n}\n.query-btn-box[data-v-476550b4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin-top: 20px;\n}\n", ""]);

// exports
